import { CurrentAccountTaxpayerStatsCard } from '@/app/modules/current-account/components/CurrentAccountTaxpayerStatsCard';
import { TaxReturnCard } from '@/app/modules/tax-returns/components/TaxReturnCard';
import { useTaxReturn } from '@/app/modules/tax-returns/hooks/useTaxReturn';

interface PaymentReferenceProps {
  id: string;
}

export function PaymentReference({ id }: PaymentReferenceProps) {
  const { data, isLoading, error } = useTaxReturn(id);

  if (isLoading || error) {
    return;
  }

  return (
    <>
      <TaxReturnCard id={id} />
      <CurrentAccountTaxpayerStatsCard col={12} taxpayerId={data?.taxpayer.id ?? ''} />
    </>
  );
}
